<template>
  <!--省市县三级联动-->
  <!-- <el-form :model="formModelData"  :label-position='labelPosition'> -->
  <el-col class="areaLink" :span="24" v-if="config.isShow==undefined || config.isShow==null || config.isShow">
    <el-col :span="calcProvinceWidth" >
      <el-form-item :label-width="labelWidth" :prop="provinceProp" :rules="checkRules('provniceRules',config)"
        :label="provinceLabel" style="text-align: left;" >
        <!-- <span v-if="item.type ==='label'" style="word-break:break-all">{{ formModel[item.prop] }}</span> -->
        <el-select v-model="formModelData[provinceProp]" :placeholder="config.placeholder" clearable
          filterable @change="changeProvnice" :disabled="config.disabled">
          <el-option v-for="option in provinceList" :key="option.id" :label="option.label" :value="option.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="calcOtherWidth"  :style="{padding:calcSelectPadding}">
      <el-form-item :label-width="(cityLabel?labelWidth:'0')" :prop="cityProp" :rules="checkRules('cityRules',config)"
        :label="cityLabel" style="text-align: left;" >
        <!-- <span v-if="item.type ==='label'" style="word-break:break-all">{{ formModel[item.prop] }}</span> -->
        <el-select v-model="formModelData[cityProp]" :placeholder="config.placeholder" clearable
          filterable @change="changeCity" :disabled="config.disabled">
          <el-option v-for="option in cityList" :key="option.id" :label="option.label" :value="option.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-col>

    <el-col :span="calcOtherWidth">
      <el-form-item :label-width="(xianLabel?labelWidth:'0')" :prop="xianProp" :rules="checkRules('xianRules',config)"
        :label="xianLabel" style="text-align: left;">
        <!-- <span v-if="item.type ==='label'" style="word-break:break-all">{{ formModel[item.prop] }}</span> -->
        <el-select v-model="formModelData[xianProp]" :placeholder="config.placeholder" clearable
          filterable @change="changeXian" :disabled="config.disabled">
          <el-option v-for="option in xianList" :key="option.id" :label="option.label" :value="option.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-col>
  </el-col>
  <!-- </el-form> -->
</template>

<script>
  import fwUtil from 'framework-util'
  import lodash from 'lodash'
  export default {
    props: {
      labelWidth: {
        type: String,
        default: '80px'
      },
      labelPosition:{
        type:String,
        default:'top'
      },
      config: {
        type: Object,
        default () {
          return {

          }
        }
      },
      formModel: {
        type: Object,
        default () {
          return {
          }
        }
      }
    },
    data() {
      return {
        formModelData: {
        },
        provinceList: [],
        cityList: [],
        xianList: []
      }
    },
    watch: {
      formModel: {
        handler(newValue, oldValue) {
          this.formModelData = lodash.cloneDeep(this.newValue)
          this.getProvinceList()
          this.getCityList()
          this.getXianList()
        },
        deep: true
      }
    },
    computed:{
      calcSelectPadding(){
        return '0 10px'
      },
      calcProvinceWidth(){
        if(this.labelPosition==='top'){
          return 8
        }
        return 10
      },
      calcOtherWidth(){
        if(this.labelPosition==='top'){
          return 8
        }
        return 7
      },

      provinceProp(){
        return this.config.propConfig["provnice"]
      },
      cityProp(){
        return this.config.propConfig["city"]
      },
      xianProp(){
        return this.config.propConfig["xian"]
      },
      provinceLabel(){
        if(this.config && this.config.labels  && this.config.labels.provnice){
          return this.config.labels.provnice
        }
        return this.config.label
      },
      cityLabel(){
       if(this.config && this.config.labels  && this.config.labels.city){
         return this.config.labels.city
       }
       return null
      },
      xianLabel(){
        if(this.config && this.config.labels  && this.config.labels.xian){
          return this.config.labels.xian
        }
        return null
      }
    },
    mounted() {
      this.formModelData = lodash.cloneDeep(this.formModel)
      this.getProvinceList()
      this.getCityList()
      this.getXianList()
    },
    methods: {

      checkRules(field, item) {
        if (item.disabled == undefined || item.disabled == null || item.disabled == false) {
          return item.rules[field];
        }
        return []
      },
      changeProvnice() {
        this.getCityList()
        this.formModelData[this.cityProp] = null
        this.getXianList()
        this.formModelData[this.xianProp] = null
        this.$emit("change", this.config, this.formModelData)
      },
      changeCity() {
        this.getXianList()
        this.formModelData[this.xianProp] = null
        this.$emit("change", this.config, this.formModelData)
      },
      changeXian() {
        debugger
        this.$emit("change", this.config, this.formModelData)
      },
      getProvinceList() {
        fwUtil.DictUtil.getUrlLinkList("dict/area?pId=").then((res) => {
          this.provinceList = res
          this.cityList = []
          this.xianList = []
        })
      },
      getCityList() {
        if (this.formModelData[this.provinceProp]) {
          fwUtil.DictUtil.getUrlLinkList("dict/area?pId=" + this.formModelData[this.provinceProp]).then((res) => {
            this.cityList = res
            this.xianList = []
          })
        } else {
          this.cityList = []
          this.xianList = []
        }
      },
      getXianList() {
        if (this.formModelData[this.cityProp]) {
          fwUtil.DictUtil.getUrlLinkList("dict/area?pId=" + this.formModelData[this.cityProp]).then((res) => {
            this.xianList = res
          })
        } else {
          this.cityList = []
          this.xianList = []
        }
      }
    }

  }
</script>

<style scoped="scoped">
  .areaLink .el-select{
    width: 100% !important;
   }
</style>



// WEBPACK FOOTER //
// src/components/basic/FwAreaLink.vue